import { VideoProvider } from '@recruitee/interview-events-types';
import { createSingleEntityStore } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<VideoProvider[]>()('InterviewVideoProvider');

export {
  actions as InterviewVideoProvidersActions,
  selectors as InterviewVideoProviderSelectors,
  reducer as InterviewVideoProviderReducer,
  namespace as InterviewVideoProviderNamespace,
};
